import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';
import { applyDomainFilterToQuery } from './useDomainQuery';

export const useUnreadMessages = () => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const { user } = useAuth();

  const fetchUnreadCount = async () => {
    if (!user) {
      setUnreadCount(0);
      setLoading(false);
      return;
    }

    try {
      let query = supabase
        .from('contact_messages')
        .select('*', { count: 'exact', head: true })
        .eq('read', false);
      
      // Appliquer le filtrage par domaine
      query = applyDomainFilterToQuery(query);
      
      const { count, error } = await query;

      if (error) {
        console.error('Erreur lors de la récupération des messages non lus:', error);
        return;
      }

      setUnreadCount(count || 0);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnreadCount();

    // Abonnement aux changements dans la table des messages
    const subscription = supabase
      .channel('contact_messages_changes')
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table: 'contact_messages' 
        }, 
        () => {
          fetchUnreadCount();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [user]);

  return { unreadCount, loading, refetch: fetchUnreadCount };
};
